package org.maplibre.compose.demoapp.demos

internal actual val demoLocationEngines: List<DemoLocationEngine> = listOf(DefaultLocationEngine)
